import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { useLang } from "@/lib/LanguageContext";
import PageShell from "@/components/PageShell";
import ImageHero from "@/components/ImageHero";
import Seo, { faqSchema } from "@/components/Seo";

export default function FAQPage() {
  const { t } = useLang();
  const f = t.faq;

  return (
    <PageShell>
      <Seo title={f.seoTitle} description={f.seoDesc} schema={faqSchema(f.items)} />

      <ImageHero testId="faq-hero" image="heroHomeAlt" eyebrow={f.eyebrow} titleA={f.title} />

      <section data-testid="faq-list" className="py-16 sm:py-32 px-6 lg:px-10">
        <div className="max-w-4xl mx-auto space-y-10">
          {f.items.map((item, i) => (
            <div key={item.q} data-testid={`faq-item-${i}`} className="border-b border-stone-200 pb-8">
              <h2 className="font-medium text-stone-900 text-lg">{item.q}</h2>
              <p className="mt-3 text-stone-600 leading-relaxed">{item.a}</p>
            </div>
          ))}
        </div>
      </section>

      <section data-testid="faq-cta" className="bg-stone-100 border-t border-stone-200 py-16 sm:py-32 px-6 lg:px-10 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-serif text-4xl sm:text-5xl font-light text-stone-900">{t.finalCta.title}</h2>
          <Link
            data-testid="faq-cta-contact"
            to="/contact"
            className="mt-10 inline-flex items-center justify-center gap-3 bg-slate-900 text-stone-50 px-8 py-4 text-sm font-medium hover:bg-slate-800 transition-colors"
          >
            {t.finalCta.cta}
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </PageShell>
  );
}
